import React from "react"
import styles from "./styles.scss"
import Step from "./Step"
import posed from "react-pose"

const PosedChild = posed.div({
  enter: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0 },
})

const PosedLine = posed.div({
  enter: { scaleX: 1, transition: { type: "tween", duration: 1200 } },
  exit: { scaleX: 0 },
})

let Posed = posed.div()

class DiagonalLine extends React.PureComponent {
  componentWillUpdate() {
    if (!this.props.chartRevealed) {
      Posed = posed.div({
        enter: {
          rotate: `-${this.props.angle}deg`,
          transition: { duration: 1200 },
          staggerChildren: 150,
        },
        exit: { rotate: 0 },
      })
    }
  }

  render() {
    const {
      steps,
      activeStepId,
      angle,
      hypotenuse,
      chartRevealed,
      onHover,
      iconWidth,
    } = this.props
    const inlineStyle = {
      width: `${hypotenuse}px`,
      transform: `rotate(-${angle}deg)`,
    }

    return (
      <React.Fragment>
        <Posed
          style={inlineStyle}
          className={styles.diagonalLineContainer}
          initialPose="exit"
          pose={chartRevealed ? "enter" : "exit"}
        >
          <PosedLine className={styles.diagonalLine} />
          <span />
          {steps.map(step => (
            <PosedChild key={step.id}>
              <Step
                step={step}
                angle={angle}
                onHover={onHover}
                iconWidth={iconWidth}
                isActive={step.id === activeStepId}
              />
            </PosedChild>
          ))}
          <span />
        </Posed>
        <Posed
          className={styles.halfBackground}
          style={inlineStyle}
          initialPose="exit"
          pose={chartRevealed ? "enter" : "exit"}
        />
      </React.Fragment>
    )
  }
}

export default DiagonalLine



// WEBPACK FOOTER //
// ./src/pages/LandingPage/Chart/DiagonalLine/index.jsx